import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 2.99995L9 7.99995H4V2.99995ZM1.28194 2.99995H3V8.99995H9V14.718C9 15.1638 8.95359 15.3254 8.86643 15.4884C8.77928 15.6513 8.65139 15.7792 8.48842 15.8664C8.32546 15.9535 8.16382 15.9999 7.71806 15.9999H1.28194C0.836183 15.9999 0.67454 15.9535 0.511577 15.8664C0.348614 15.7792 0.22072 15.6513 0.133566 15.4884C0.0464128 15.3254 0 15.1638 0 14.718V4.28189C0 3.83613 0.0464128 3.67449 0.133566 3.51153C0.22072 3.34856 0.348614 3.22067 0.511577 3.13352C0.67454 3.04636 0.836183 2.99995 1.28194 2.99995ZM3 0H7L12 5V12C12 12.5523 11.5523 13 11 13H10V7L5 2H2V1C2 0.447715 2.44772 0 3 0Z",
		fill: "#545E6B"
	})]
});
const ForwardRef = forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
